var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-container"},[_c('input',{ref:"inputText",staticClass:"input-ticketing",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)},"focus":_vm.handleFocus,"blur":_vm.handleBlur}})])
}
var staticRenderFns = []

export { render, staticRenderFns }